<template>
    <dv-scroll-ranking-board :config="config" style="width:500px;height:300px" />
  </template>
  
  <script>
  export default {
    name: "Storelocation",
    data() {
      return {
        config: {},
        //折线数据
  
        message: {
  
          data: [
            {
              name: '餐饮类门店',
              value: 119
            },
            {
              name: '零售类门店',
              value: 180
            },
            {
              name: '服务类门店',
              value: 141
            },
            {
              name: '其他特色类型',
              value: 9
            }
          ],
  
        },
  
      }
    },
    methods:{
      init(){
        this.config = this.message
      }
    },
    mounted() {
      //初始化
      this.init();
    },
    created() {
      let user_id = window.localStorage.getItem('user_id');
  
      const data = {
        'user_id': user_id
      };
  
      // this.$api.zga_area_num(data).then(res=>
      // {
      //   this.config ={
  
      //     data:res
  
      //   }
      // })
    },
    watch: {
      message(value) {
        this.init();
      },
    }
  }
  </script>
  
  <style scoped>
  
  </style>